import { icon } from 'leaflet'; // This import is fine, no need to remove it.
import { cookieSet, cookieGet } from './helpers';

export default class LayoutSwitcher {
    constructor() {
        this.buttonsContainer = document.querySelector('.archive-layout-toggler');
        this.buttons = [...this.buttonsContainer.querySelectorAll('button')];
        this.currentCookie = null;
        this.wrapper = document.querySelector('.products-list-wrapper');

        this.getCurrentCookie();
        this.initListeners();
    }

    getCurrentCookie = async () => {
        const tempCookie = cookieGet('layout');

        if (tempCookie === null) {
            this.currentCookie = 'grid';
            cookieSet('layout', 'grid', '', '9999');
            return;
        }

        this.currentCookie = tempCookie;
    };

    toggleButtonsClasses = async () => {
        this.buttons.forEach((button) => {
            const svgIcon = button.querySelector('svg'); // Use a local variable
            if (svgIcon) {
                svgIcon.classList.toggle('active'); // Toggle the class on the SVG element
            }
        });
    };

    handleClick = async ({ currentTarget }) => {
        if (currentTarget.name === this.currentCookie) return;

        this.currentCookie = currentTarget.name;
        cookieSet('layout', currentTarget.name, '', '9999');

        this.toggleButtonsClasses();
        this.wrapper.classList.toggle('container-table-layout');
    };

    initListeners = async () => {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (e) => {
                this.handleClick(e);
            });
        });
    };
}
